import { FieldValues } from 'react-hook-form'
import { RootState, store } from './agent.store'
import {
  componentNames,
  INTEGRATION_LOGS,
  MODE_CONSTANTS,
  USER_PROFILES,
} from './constants'
import { FieldDataByFieldNameType } from '@app-store'
import { NAMESPACE } from '@ui-kit'

export const isSuperAdmin = (): boolean => {
  return store.getState()?.authUser?.user?.superAdmin ?? false
}

export const isReadOnlyUser = (): boolean => {
  return (
    store.getState()?.authUser?.user?.profile === USER_PROFILES.READ_ONLY_USER
  )
}

export const isProgramAdmin = (): boolean => {
  return (
    store.getState()?.authUser?.user?.profile === USER_PROFILES.PROGRAM_ADMIN
  )
}

export const canViewCentralizedIntegrationLogs = (
  state: RootState = store.getState()
): boolean => {
  const profile = state?.authUser?.user?.profile
  const programPermissions = state?.clientPermissions?.programPermissions

  switch (profile) {
    case USER_PROFILES.SUPERADMIN:
    case USER_PROFILES.PROGRAM_ADMIN:
    case USER_PROFILES.SUPPORT:
      return true
    case USER_PROFILES.STANDARD_USER: {
      return Object.values(programPermissions ?? {}).some((permissions) => {
        const integrationLogs = permissions?.[INTEGRATION_LOGS.INTEGRATION]
        return Boolean(
          integrationLogs?.['View Only'] || integrationLogs?.['Manage']
        )
      })
    }
    case USER_PROFILES.READ_ONLY_USER:
    default:
      return false
  }
}

export const currentUserId = (): number => {
  return store.getState()?.authUser?.user?.id ?? -1
}

export const hasPermission = (
  mode: (typeof MODE_CONSTANTS)[keyof typeof MODE_CONSTANTS],
  entityId: number | string,
  fieldId?: number | string
): boolean => {
  if (isSuperAdmin() || !isSuperAdmin()) return true

  //NOTE: Logging these parameters for now as we will modify this later
  console.log(mode, entityId, fieldId)

  // const entityPermissions =
  //   store.getState()?.permissions?.fieldPermissions?.[entityId]
  // if (entityPermissions === undefined) return false

  // if (fieldId !== undefined) {
  //   if (entityPermissions.canCreate) return true

  //   const fieldPermissions = entityPermissions.fieldPermissions ?? {}
  //   if (mode === MODE_CONSTANTS.VIEW)
  //     return (
  //       (entityPermissions.canView ?? false) &&
  //       (fieldPermissions[fieldId]?.canView ?? true)
  //     )
  //   if (mode === MODE_CONSTANTS.EDIT)
  //     return (
  //       (entityPermissions.canEdit ?? false) &&
  //       (fieldPermissions[fieldId]?.canEdit ?? true)
  //     )
  // } else {
  //   if (mode === MODE_CONSTANTS.ADD) return entityPermissions.canCreate ?? false
  //   if (mode === MODE_CONSTANTS.EDIT) return entityPermissions.canEdit ?? false
  //   if (mode === MODE_CONSTANTS.VIEW) return entityPermissions.canView ?? false
  // }
  return false
}

export const hideUnauthorizedData = (
  data: FieldValues,
  added_fields: FieldDataByFieldNameType,
  entityId: string | number,
  applyForAllDataType = true,
  fieldsToIgnore: string[] = [],
  prefix = ''
) => {
  Object.entries(added_fields).forEach(([fieldName, field]) => {
    if (prefix) fieldName = prefix + '.' + fieldName
    if (
      !(
        [componentNames.SINGLE_LOOKUP, componentNames.MULTI_LOOKUP] as string[]
      ).includes(field?.ui_data_type ?? '')
    ) {
      if (
        !hasPermission(
          MODE_CONSTANTS.VIEW,
          entityId,
          field?.field_id ?? undefined
        ) &&
        !fieldsToIgnore.includes(fieldName.split('.').pop() ?? '')
      )
        data[fieldName] =
          (
            [componentNames.SINGLE_LINE, componentNames.MULTI_LINE] as string[]
          ).includes(field?.ui_data_type ?? '') || applyForAllDataType
            ? NAMESPACE.REDACTED
            : null
    }
    if (field?.added_fields) {
      hideUnauthorizedData(
        data,
        field.added_fields,
        field.relationship?.target_entity_id ?? 0,
        applyForAllDataType,
        fieldsToIgnore,
        prefix + fieldName
      )
    }
  })
}

export const caseTypePermissionMapping = (caseType: string) => {
  const permissionMapping =
    store.getState()?.clientPermissions.permissionServices
  return permissionMapping[caseType]
}

export const getReverseMapping = () => {
  const permissionServices =
    store.getState()?.clientPermissions?.permissionServices
  const reverseMapping: { [key: string]: string[] } = {}
  for (const key in permissionServices) {
    const value = permissionServices[key]
    if (reverseMapping[value]) {
      reverseMapping[value].push(key)
    } else {
      reverseMapping[value] = [key]
    }
  }
  return reverseMapping
}

export const isCaseType = (caseType: string) => {
  const permissionServices =
    store.getState()?.clientPermissions?.permissionServices
  return caseType in permissionServices
}
